<template>
  <div class="wg-row page-body">
    <wg-modal width="80%" v-if="showTerms">
      <div slot="body" class="wg-row">
        <h1 style="font-weight:500;font-size:20px;margin:0;padding:10px 0;color: #999;">
          {{ $anm22.strLang(lang, 'Privacy & Terms', 'Privacy & Termini') }}
        </h1>
        <h2 style="font-weight:normal;font-size:14px;margin:0;padding:0 0 10px 0;color:#000;">
          {{ $anm22.strLang(lang, 'Last update: ', 'Ultimo aggiornamento: ') + termsLastUpdate }}
        </h2>
        <div 
            style="height:50vh;overflow:auto;padding:10px;border:1px solid #ccc;border-radius:2px;font-size:16px;margin-bottom:20px;"
            v-html="terms"
        ></div>
        <input type="button" :value="$anm22.strLang(lang, 'Accept', 'Accetta')" @click="acceptTerms">
      </div>
    </wg-modal>
    <div class="login-container">
      <div v-if="errorString" id="anm22_wb_allarm">
        {{ $anm22.strLang(lang, 'ATTENTION: ', 'ATTENZIONE: ') + errorString }}
      </div>
      <form @submit.prevent="login">
        <h1 style="font-weight:bold;font-size:24px;margin:0;padding:10px 0;margin:10px 0;">
          {{ $anm22.strLang(lang, 'Sign in', 'Accedi') }}
        </h1>
        <div class="wg-row" style="max-width:300px;min-width:200px;margin:0 auto;padding:0;border:0;">
          <div class="wg-row com-anm22-app-text-m">
            Email
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <input type="text" v-model="email">
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row com-anm22-app-text-m">
            Password
          </div>
          <div class="vertical-height-div" style="height:5px;"></div>
          <div class="wg-row">
            <input type="password" v-model="password">
          </div>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <input type="submit" :value="$anm22.strLang(lang, 'Sign in', 'Accedi')" />
        <input type="hidden" name="log" value="ok" />
      </form>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div >
        <a
          :href="'https://www.spiagge.it/password-dimenticata/?cbue=' + cbRoute"
          style="vertical-align:middle;color:#999;"
        >
          {{ $anm22.strLang(lang, 'Forgot password?', 'Password dimenticata?') }}
        </a>
      </div>
      <template v-if="false && !isApp">
        <div
          style="width:100%; border-bottom:1px solid #ccc;font-size:0px;height:0px;margin:15px auto 20px auto;"
        ></div>
        <div
          :style="'background-image: url(' + $anm22.icons.getWorldIcon('facebookWhite') + ');'"
          class="fb-login-btn"
          @click="fbLoginClick"
        >
          <div class="label">
            {{ $anm22.strLang(lang, 'Continue with Facebook', 'Continua con Facebook') }}
          </div>
        </div>
      </template>
      <div
        style="width:100%; border-bottom:1px solid #ccc; font-size: 0px; height:0px; margin: 20px auto;"
      ></div>
      <input type="button" :value="$anm22.strLang(lang, 'Sign up', 'Registrati')" @click="signUp">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      lang: (navigator.language || navigator.userLanguage).substring(0,2),
      cbRoute: '/',
      errorString: '',
      email: "",
      password: "",
      terms: '',
      termsLastUpdate: '',
      showTerms: false,
      fbLoginStatus: null
    };
  },
  computed: {
    ...mapState({
      userLogged: state => state.auth.userLogged,
      windowHeight: state => state.windowHeight
    }),
    isApp() {
      return this.$anm22.getCookie('anm22_world_app_mode') !== "";
    }
  },
  methods: {
    manageErrors(code) {
      switch(code) {
        case 1:
          this.errorString = this.$anm22.strLang(
            this.lang,
            'Invalid email address! Please, try again.',
            'Indirizzo non valido! Provare nuovamente.'
          );
          break;
        case 2:
          this.errorString = this.$anm22.strLang(
            this.lang,
            'Empty password! Please, try again.',
            'Nessuna password inserita! Provare nuovamente.'
          );
          break;
        case 3:
          this.errorString = this.$anm22.strLang(
            this.lang,
            'Wrong email or password! Please, try again.',
            'Indirizzo o password errati! Provare nuovamente.'
          );
          break;
        case 4:
          this.errorString = this.$anm22.strLang(
            this.lang,
            'You don\'t have the right authorization to access to this app section.',
            'Autorizzazione negata per l\'accesso a questa sezione dell\'applicazione.'
          );
          break;
        default:
          this.errorString = this.$anm22.strLang(this.lang, 'An error has occured', 'C\'è stato un errore');
      }
    },
    login() {
      this.errorString = '';
      this.$http
        .post("auth/login", {
          email: this.email,
          password: this.$anm22.MD5(this.password)
        })
        .then(response => {
          if(!response.data.error) {
            this.lang = response.data.lang;
            if(response.data.validSignature) {
              this.redirect();
            } else {
              this.terms = response.data.terms;
              this.termsLastUpdate = this.$moment.unix(response.data.lastUpdate).format('LL');
              this.showTerms = true;
            }
          } else {
            this.manageErrors(response.data.error);
          }
        })
        .catch(error => {});
    },
    redirect() {
      //Login ha avuto successo, redirect
      this.$store.dispatch('auth/startLoginCheck')
      .then(() => {
        this.$router.push(this.cbRoute);
      });
    },
    fbLoginClick() {
      if(this.fbLoginStatus !== 'connected') {
        window.FB.login(response => {
          // handle the response
          if(response.status === 'connected') {
            this.fbLogin();
          } else {
            //Errore da stampare
          }
        }, {scope: 'email'});
      } else {
        this.fbLogin();
      }
    },
    fbLogin() {
      window.FB.api('/me?fields=id,name,email,first_name,last_name', async fbResponse => {
        try {
          const loginResponse = await this.$http.post("auth/fbLogin", fbResponse);
          if(!loginResponse.data.error) {
            this.lang = loginResponse.data.lang;
            if(loginResponse.data.validSignature) {
              this.redirect();
            } else {
              this.terms = loginResponse.data.terms;
              this.termsLastUpdate = this.$moment.unix(loginResponse.data.lastUpdate).format('LL');
              this.showTerms = true;
            }
          } else {
            if(loginResponse.data.error == 1) {
              // Redirect su registrazione con parametri precompilati
              let absoluteUrl = "https://www.anm22.it/app/world/registration_fb.php?food=1&cbue=" + encodeURIComponent('../' + window.location.href.split('/')[4] + this.cbRoute);
              absoluteUrl += '&f=' + fbResponse['id'] + '&e=' + fbResponse['email'] + '&n=' + fbResponse['first_name'] + '&s=' + fbResponse['last_name'];
              window.location = absoluteUrl;
            }
          }
        } catch(e) {
          
        }
      })
    },
    signUp() {
      const absoluteUrl = "https://www.spiagge.it/registrazione-utente/?cbue=" + encodeURIComponent('../' + window.location.href.split('/')[4] + this.cbRoute);
      window.location = absoluteUrl;
    },
    acceptTerms() {
      this.$http
        .post('auth/terms')
        .then(response => {
          this.redirect();
        })  
        .catch(error => {});
    }
  },
  created() {
    /* Return url */
    if(this.$route.query && this.$route.query.cb) {
      this.cbRoute = decodeURI(this.$route.query.cb);
    }
    if(this.userLogged) {
      this.$router.push('/');
    }
    /* Google analytics */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    window.ga('create', 'UA-40652727-1', 'auto');
    window.ga('send', 'pageview');
    /* FB Login - solo se non all'interno di un app Android o iOS */
    if(!this.isApp) {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: "746342188714963",
          cookie     : true,
          xfbml: true,
          version: "v2.12"
        });
  
        //This function should be here, inside window.fbAsyncInit
        window.FB.getLoginStatus(function(response) {
          this.fbLoginStatus = response.status;
        });
      };
  
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }
    this.$Progress.finish();
  }
};
</script>

<style lang="scss" scoped>
.page-body {
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 555px;
  background-color: #f9f9f9;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.login-container {
  padding: 20px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  border-radius: 2px;
  margin-top: 20px;
}
.fb-login-btn {
  color:#fff;
  background-color: #3975ea;
  border-radius: 8px;
  padding: 14px 0;
  margin: 0 auto;
  display: inline-block;
  background-position: 8px center;
  background-repeat:no-repeat;
  background-size: 30px;
  cursor: pointer;

  .label {
    color: rgb(255, 255, 255);
    padding: 0px 16px 0px 46px;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
